import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import PlaylistRemove from '@mui/icons-material/PlaylistRemove';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';

const PilihanAddressbook = ({pilihan, setPilihan}) => {
  const handleRemove = (removeItem) => {
    setPilihan((pilihan) => {
      let tmp = pilihan.filter((item) => {
        return item.code !== removeItem.code;
      });
      return tmp ? tmp : [];
    });
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      pilihan,
      result.source.index,
      result.destination.index,
    );

    setPilihan(items);
  }

  const handleClearALl = () => {
    setPilihan([]);
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    background: isDragging ? 'lightgreen' : '#F4F7FE',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
  });

  return (
    <>
      <Box
        component='div'
        sx={{
          borderBottom: '1px solid lightgray',
          background: '#FFFFFF',
          color: 'white',
          fontWeight: '700',
        }}
      >
        <Tooltip title='Hapus Pilihan'>
          <IconButton
            aria-label='close'
            onClick={() => {
              handleClearALl();
            }}
            sx={{
              padding: 0,
              position: 'initial',
              right: 8,
              top: 8,
              color: 'black',
            }}
          >
            <PlaylistRemove />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        component='div'
        sx={{
          p: '8px 3px',
          // border: '1px solid lightgray',
          color: 'black',
          height: 'calc( 100% - 64px)',
          overflowY: 'auto',
          fontSize: '9pt',
        }}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='droppable'>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {pilihan &&
                  pilihan.map((item, index) => (
                    <Draggable
                      key={item.id.toString()}
                      draggableId={item.id.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => {
                        if (snapshot.isDragging) {
                          provided.draggableProps.style.left =
                            provided.draggableProps.style.offsetLeft;
                          provided.draggableProps.style.top =
                            provided.draggableProps.style.offsetTop;
                        }
                        return (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style,
                            )}
                          >
                            <div
                              style={{
                                display: 'flex',
                                padding: '3px',
                              }}
                            >
                              <div style={{width: '90%'}}>{item.text}</div>
                              <div style={{width: '10%', textAlign: 'right'}}>
                                <IconButton
                                  aria-label='close'
                                  onClick={() => {
                                    handleRemove(item);
                                  }}
                                  sx={{
                                    padding: 0,
                                    position: 'initial',
                                    right: 8,
                                    top: 8,
                                    color: 'black',
                                    fontSize: '10pt',
                                  }}
                                >
                                  <CloseIcon
                                    style={{
                                      fontSize: '12pt',
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </div>
                            <Divider />
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </>
  );
};

export default PilihanAddressbook;

PilihanAddressbook.propTypes = {
  pilihan: PropTypes.array,
  setPilihan: PropTypes.func,
};
